import { BIModel } from './BIModel';

// Cuando le dan a "Borrar filtros/Restablecer" (tanto nativos como des de WebView).

export class TmpFilterResetBIModel extends BIModel {

  static eventName = 'tmp_filter_reset';

  constructor(userId) {
    super(TmpFilterResetBIModel.eventName, userId);
  }

  get modelData() {
    return {};
  }

}

